import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const LearningSection = ({ title, icon, children, className = '' }) => {
  if (!children) return null;

  return (
    <section className={`rounded-xl border border-slate-200 bg-white p-6 shadow-sm ${className}`}>
      <div className="flex items-center gap-2">
        <SafeIcon icon={icon} className="h-4 w-4 text-blue-600" />
        <h2 className="text-sm font-bold uppercase tracking-widest text-slate-800">{title}</h2>
      </div>
      <div className="mt-4 text-sm leading-relaxed text-slate-600">
        {children}
      </div>
    </section>
  );
};

export default LearningSection;
